export function getCurrentRoleContext() {
	let userRole = {};
	let userDetails = [];
	let userDataAll = {};
	try {
		userRole = JSON.parse(localStorage.getItem('selectedLoginData')) || {};
		userDetails = JSON.parse(localStorage.getItem('userDetails')) || [];
		userDataAll = JSON.parse(localStorage.getItem('userDetailsAll')) || {};
	} catch {
		/* ignore malformed storage */
	}

	const roles = userDetails?.find((e) => parseInt(e?.roles_id) === parseInt(userRole?.role_id));
	const roleName = userDataAll?.session_info?.role_name || roles?.role_name || null;

	return { userRole, userDetails, userDataAll, roles, roleName };
}

function buildMenuList({ roles, roleName }) {
	const role_data = roleName;
	const isRoomopsMonitor = role_data && role_data.toLowerCase() === 'roomops monitor';
	const isRoomopsAdmin = role_data && role_data.toLowerCase() === 'roomops admin';
	const isRoomopsManager = role_data && role_data.toLowerCase() === 'roomops manager';
	const isRoomopsRole = role_data && (
		role_data.toLowerCase().includes('roomops') ||
		isRoomopsMonitor ||
		isRoomopsAdmin ||
		isRoomopsManager
	);

	return [

    // house keeping request
    // {   
    //     title:'Dashboard',
    //     //classsChange: 'mm-collapse',
    //     iconStyle: <i className="material-icons">grid_view</i>,
    //     to: 'housekeeping-request',
    // },
    // Conditionally add Forecasts section - only show for non-roomops roles
    ...(!isRoomopsRole && (roles?.role_name === 'executive housekeeper' || roles?.role_name === 'housekeeping supervisor') ? [
        // {
        //     title: 'Forecasts',
        //     classsChange: 'mm-collapse',
        //     content: [
        //         {
        //             title: 'Forecast Update',
        //             to: 'forecast/update',
        //         },
        //     ],
        // },
        {
            title: 'Function Time Report',
            to: 'function-time-segments-report',
        },
        {
            title: 'Performance Management Report',
            to: 'performance-management-report',
        },
        {
            title: 'Performance Variances',
            to: 'performance-variances-report',
        },
        {
            title: 'Reservation Report',
            to: 'reservation-report',
        },
        {
            title: 'Timecard Report',
            to: 'timecard-report',
        },
    ] : []),
    // Only show these menu items for non-roomops roles
    ...(!isRoomopsRole && !(roles?.role_name === 'lead room attendant' || roles?.role_name === 'room attendant'
        || roles?.role_name === 'executive housekeeper' || roles?.role_name === 'housekeeping supervisor') ? [
        {
            title: 'Incoming Requests',
            to: 'housekeeping-request',
        },
        {
            title: 'Properties List',
            to: 'properties-list',
        },
        {
            title: 'Ownership Records',
            to: 'ownership-list',
        },
        {
            title: 'Manage Requests',
            to: 'manage-requests',
        }
    ] : []),
    // Only show these menu items for non-roomops roles
    ...(!isRoomopsRole ? [
        {
            title: 'Housekeeping Stats',
            to: 'housekeeping-stats',
        },
        {
            title: 'Resource Status',
            to: 'resource-stats'
        },
        {
            title: 'Shift Details',
            to: 'shift-details'
        },
        {
            title: 'Resource Model',
            to: 'resource-model'
        },
    ] : []),
    // Room Status Monitor - unified multi-property monitor for all roles
    // (portfolio managers see all active properties; others see their login property)
    {
        title: 'Room Status Monitor',
        to: 'multi-property-monitor'
    },
    // Room Status History - show for all roles
    {
        title: 'Room Status History',
        to: 'room-status-history'
    }
	];
}

/** Sidebar items for the currently selected property/role (recomputed on each call). */
export function getMenuList() {
	return buildMenuList(getCurrentRoleContext());
}

/** @deprecated Import-time snapshot — prefer getMenuList() so role changes stay in sync. */
export const MenuList = getMenuList();
